export default Object.freeze({
  DRAFT: 'draft',
  ACTIVE: 'active',
  FINISHED: 'finished',
  ARCHIVED: 'archived',
});
